import { render } from "./SupplierComponent.vue?vue&type=template&id=0294ca02"
import script from "./SupplierComponent.vue?vue&type=script&lang=js"
export * from "./SupplierComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/components/admin/settings/Supplier/SupplierComponent.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "0294ca02"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('0294ca02', __exports__)) {
    api.reload('0294ca02', __exports__)
  }
  
  module.hot.accept("./SupplierComponent.vue?vue&type=template&id=0294ca02", () => {
    api.rerender('0294ca02', render)
  })

}


export default __exports__